import { api } from './api';

export const adminAPI = {
  claim: (secret) => api.post('/admin/claim', { secret }).then(r => r.data),
  me: () => api.get('/admin/me').then(r => r.data),
  stats: () => api.get('/admin/stats').then(r => r.data),
  users: (q = '') => api.get('/admin/users', { params: q ? { q } : {} }).then(r => r.data),
  user: (id) => api.get(`/admin/users/${id}`).then(r => r.data),
  updateUser: (id, patch) => api.patch(`/admin/users/${id}`, patch).then(r => r.data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`).then(r => r.data),
  listAdmins: () => api.get('/admin/admins').then(r => r.data),
  promoteAdmin: (email) => api.post('/admin/admins/promote', { email }).then(r => r.data),
  demoteAdmin: (user_id) => api.post('/admin/admins/demote', { user_id }).then(r => r.data),
  notifyUser: (userId, payload) => api.post(`/admin/users/${userId}/notify`, payload).then(r => r.data),
  impersonate: (userId) => api.post(`/admin/users/${userId}/impersonate`).then(r => r.data),
  setTrading: (userId, payload) => api.patch(`/admin/users/${userId}/trading`, payload).then(r => r.data),
  userPositions: (userId) => api.get(`/admin/users/${userId}/positions`).then(r => r.data),
  allPositions: () => api.get('/admin/positions').then(r => r.data),
  editPosition: (id, payload) => api.patch(`/admin/positions/${id}`, payload).then(r => r.data),
  closePosition: (id, close_price) => api.post(`/admin/positions/${id}/close`, { close_price }).then(r => r.data),
  settlePosition: (id, pnl, close_price) => api.post(`/admin/positions/${id}/settle`, { pnl, close_price }).then(r => r.data),
  settleAll: (userId, mode, amount) => api.post(`/admin/users/${userId}/settle-all`, { mode, amount }).then(r => r.data),
  getSpread: () => api.get('/admin/settings/spread').then(r => r.data),
  setSpread: (payload) => api.patch('/admin/settings/spread', payload).then(r => r.data),
  getEmailSettings: () => api.get('/admin/settings/email').then(r => r.data),
  setEmailSettings: (payload) => api.patch('/admin/settings/email', payload).then(r => r.data),
  emailLog: (limit = 100) => api.get('/admin/email-log', { params: { limit } }).then(r => r.data),
  auditLog: () => api.get('/admin/audit').then(r => r.data),
  transactions: (params = {}) => api.get('/admin/transactions', { params }).then(r => r.data),
  updateTx: (id, status, note) => api.patch(`/admin/transactions/${id}`, { status, note }).then(r => r.data),
  kycList: (status) => api.get('/admin/kyc', { params: status ? { kyc_status: status } : {} }).then(r => r.data),
  kycDetail: (userId) => api.get(`/admin/kyc/${userId}`).then(r => r.data),
  kycReview: (userId, action, reason) => api.post(`/admin/kyc/${userId}/review`, { action, reason }).then(r => r.data),
  // Deposit accounts management
  depositAccounts: (type) => api.get('/admin/deposit-accounts', { params: type ? { type } : {} }).then(r => r.data),
  createDepositAccount: (payload) => api.post('/admin/deposit-accounts', payload).then(r => r.data),
  updateDepositAccount: (id, patch) => api.patch(`/admin/deposit-accounts/${id}`, patch).then(r => r.data),
  deleteDepositAccount: (id) => api.delete(`/admin/deposit-accounts/${id}`).then(r => r.data)
};
